import { useEffect, useState } from 'react';
import { useSearchStateFilters } from './useSearchStateFilters';
import { useSearchStateLocation } from './useSearchStateLocation';

const useFilterString = () => {
	const [ filterString, setFilterString ] = useState( '' );
	const { submarket, stateAsLocation, cities } = useSearchStateLocation();

	const { sqFtRange, priceRange, bedrooms, bathrooms, garages } = useSearchStateFilters();

	useEffect( () => {
		const filters = ["NOT home_status:'Sold OUt'"];
		if ( submarket.slug ) {
			filters.push( `submarket_slug:"${ submarket.slug }"` );
		}

		if ( stateAsLocation.abbr ) {
			filters.push( `state_alpha_2_code:"${ stateAsLocation.abbr }"` );
		}

		if ( cities.length > 0 ) {
			const citiesFilters = cities.map( ( city ) => `cities:"${ city }"` ).join( ' OR ' );
			filters.push( `(${ citiesFilters })` );
		}

		// if min is set, check that max is greater than min
		if ( sqFtRange[ 0 ] !== null ) {
			filters.push( `max_sq_feet > ${ sqFtRange[ 0 ] }` );
		}
		// if max is set, check that min is less than max
		if ( sqFtRange[ 1 ] !== null ) {
			filters.push( `min_sq_feet < ${ sqFtRange[ 1 ] }` );
		}

		// if min is set, check that max is greater than min
		if ( priceRange[ 0 ] !== null ) {
			filters.push( `max_price > ${ priceRange[ 0 ] }` );
		}
		// if max is set, check that min is less than max
		if ( priceRange[ 1 ] !== null ) {
			filters.push( `min_price < ${ priceRange[ 1 ] }` );
		}

		// Setting both min and max as min if that is set is not a typo:
		// Set both min and max values to min because it could be either and it could change with selections
		// this is for max also. And for Bedrooms, bathrooms, and garages
		if ( bedrooms.min !== null && bedrooms.max !== null ) {
			filters.push( `(min_bedrooms >= ${ bedrooms.min } OR max_bedrooms >= ${ bedrooms.max })` );
		} else if ( bedrooms.min !== null ) {
			filters.push( `(min_bedrooms >= ${ bedrooms.min } OR max_bedrooms >= ${ bedrooms.min })` );
		} else if ( bedrooms.max !== null ) {
			filters.push( `(min_bedrooms >= ${ bedrooms.max } OR max_bedrooms >= ${ bedrooms.max })` );
		}

		if ( bathrooms.min !== null && bathrooms.max !== null ) {
			filters.push( `(min_bathrooms >= ${ bathrooms.min } OR max_bathrooms >= ${ bathrooms.max })` );
		} else if ( bathrooms.min !== null ) {
			filters.push( `(min_bathrooms >= ${ bathrooms.min } OR max_bathrooms >= ${ bathrooms.min })` );
		} else if ( bathrooms.max !== null ) {
			filters.push( `(min_bathrooms >= ${ bathrooms.max } OR max_bathrooms >= ${ bathrooms.max })` );
		}

		if ( garages.min !== null && garages.max !== null ) {
			filters.push( `(min_garage >= ${ garages.min } OR max_garage >= ${ garages.max })` );
		} else if ( garages.min !== null ) {
			filters.push( `(min_garage >= ${ garages.min } OR max_garage >= ${ garages.min })` );
		} else if ( garages.max !== null ) {
			filters.push( `(min_garage >= ${ garages.max } OR max_garage >= ${ garages.max })` );
		}
		// console.log( filters.join( ' AND ' ) );
		setFilterString( filters.join( ' AND ' ) );
	}, [ submarket.slug, stateAsLocation.abbr, cities, sqFtRange, priceRange, bedrooms, bathrooms, garages ] );

	return { filterString };
};

export default useFilterString;
